import { motion } from "framer-motion";
import { useLenis } from "lenis/react";

export const Nav = () => {
  const lenis = useLenis();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el && lenis) lenis.scrollTo(el, { offset: -70 });
    else if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-[#1F1F1F] bg-black/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-4 md:px-10">
        <button
          data-testid="nav-logo"
          onClick={() => (lenis ? lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" }))}
          className="flex items-center gap-2"
        >
          <span className="text-2xl font-bold lowercase tracking-tight text-white">proof</span>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#C9A94B]">/ beta</span>
        </button>

        <nav className="hidden items-center gap-8 md:flex">
          {[
            ["how", "How it works"],
            ["showcase", "The app"],
            ["manifesto", "Manifesto"],
          ].map(([id, label]) => (
            <button
              key={id}
              data-testid={`nav-link-${id}`}
              onClick={() => scrollTo(id)}
              className="font-mono text-[11px] uppercase tracking-[0.15em] text-[#8A8A8A] transition-colors hover:text-white"
            >
              {label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-join-button"
          onClick={() => scrollTo("join")}
          className="sweep-btn border border-[#C9A94B] px-4 py-2 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-[#C9A94B] transition-colors hover:text-black"
        >
          Join
        </button>
      </div>
    </motion.header>
  );
};
